// Centralized role helpers + category labels for hierarchical RBAC

export const ADMIN_LIKE = new Set([
  "super_admin",
  "admin",
  "admin_directive",
  "admin_treasurer",
]);

export const TREASURER_ROLES = new Set([
  "super_admin",
  "admin",
  "admin_treasurer",
]);

export const STAFF_ROLES = new Set([...ADMIN_LIKE, "coach"]);

export const CATEGORIES = ["tackle", "flag_masculino", "flag_femenino"];

export const CATEGORY_LABEL = {
  tackle: "Tackle",
  flag_masculino: "Flag Masculino",
  flag_femenino: "Flag Femenino",
};

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  admin: "Admin",
  admin_directive: "Admin Directivo",
  admin_treasurer: "Admin Tesorero",
  coach: "Coach",
  player: "Jugador",
  pending: "Pendiente",
};

export const isAdminLike = (role) => ADMIN_LIKE.has(role);
export const isTreasurer = (role) => TREASURER_ROLES.has(role);
export const isStaff = (role) => STAFF_ROLES.has(role);

// Categories a user effectively has access to.
// Admin-like roles see ALL categories.
// Coach -> coach_categories. Player -> profile.categories.
export function userCategories(user, profile) {
  if (!user) return new Set();
  if (isAdminLike(user.role)) return new Set(CATEGORIES);
  if (user.role === "coach") return new Set(user.coach_categories || []);
  if (user.role === "player") return new Set(profile?.categories || []);
  return new Set();
}

// Returns true if a user can RSVP / belongs to at least one of the event's categories.
// Empty event categories means general (all club).
export function canRsvpEvent(user, profile, event) {
  const evCats = event?.categories || [];
  if (!evCats.length) return true; // general event
  if (isAdminLike(user?.role)) return true;
  const mine = userCategories(user, profile);
  return evCats.some((c) => mine.has(c));
}
